import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../user/context/AuthContext';

const PrivateRoute = ({ children }) => {
  console.log("PrivateRoute", children)
  const { isAuthenticated } = useAuth();
  console.log("isAuthenticated private routes", isAuthenticated)
  return isAuthenticated() ? children : <Navigate to="/dashboard" />;
};
export default PrivateRoute;
